import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, finalize, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'src/sb-modules/Frontend-form-field-module/common/services/form.service';
import { FormCommonDataService } from '@form-field-module/common/services/form-common-data.service';
import { FormListItemDTO } from '@sb-tools/typescript/models/dto/form-list-item.dto';
import { FormsListComponent } from '@form-field-module/forms-list/forms-list.component';

@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.scss'],
    imports: [FormsListComponent],
})
export class FormsComponent implements OnInit, OnDestroy {
    areFormsLoading = true;
    forms: FormListItemDTO[];

    private unsubscriber = new Subject<void>();

    constructor(
        private formCommonDataService: FormCommonDataService,
        private formService: FormService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit() {
        this.formCommonDataService.isInternal = true;
        this.formService
            .getAll()
            .pipe(
                finalize(() => {
                    this.areFormsLoading = false;
                }),
            )
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.forms = data;

                if (this.forms.length === 1) {
                    this.selectForm(this.forms[0]);
                }
            });
    }

    selectForm(form: FormListItemDTO) {
        this.router
            .navigateByUrl(`/${this.activatedRoute.snapshot.params.community}/${form.name}?isInternal=true`)
            .then();
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
